import produce from 'immer'
import { AiStepSchema } from '@feedyou-ai/feedbot-schema'

import { UnsetDialogsService } from '../../../types'

export const unsetDialogs: UnsetDialogsService<AiStepSchema> = (dialogIds, step) => {
  return produce<AiStepSchema>(step, result => {
    result.tools?.forEach(tool => {
      if (tool.action?.dialog && dialogIds.includes(tool.action.dialog)) {
        tool.action.dialog = undefined
      }
    })
  })
}
